import type { AmenityType } from '@/config/objects/amenity-types';
import { useOutletContext } from 'react-router-dom';

interface AmenityTypeContext {
  amenityType: AmenityType | undefined;
  isLoading: boolean;
}

export function useAmenityTypeContext() {
  return useOutletContext<AmenityTypeContext>();
}
